import {
  Component,
  ElementRef, EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit, Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  HostListener
} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {AddToCartDialogComponent} from "./add-to-cart-dialog/add-to-cart-dialog.component";
import {ActivePosMenu, Category, CategoryFoods} from '../../../../@domain/single-menu-group';
import {Section} from "../../../../@domain/section";
import {ApiBaseService} from "../../../../../../projects/vendors/src/lib/services/api-base.service";
import {CheckOption} from '../../../../../../projects/vendors/src/lib/services/form-helper';
import {ItemCategory} from "../../../../@domain/item-category";
import {ActivePos} from '../../../../@domain/active-pos';
import {FoodItemQuantity} from '../../../../@domain/food-item-quantity';
import {getMenuOrderState, getMenuState, getPlaceOrderState} from "../../../../app.reducer";
import {Store} from "@ngrx/store";
import * as fromApp from "../../../../app.reducer";
import {debounceTime, Subject} from "rxjs";
import {CartRequestDetails} from "../../../../@domain/cart-request-details";
import {HttpParams} from "@angular/common/http";
import {AlertService} from "../../../../../../projects/vendors/src/lib/services/alert.service";
import {OrderFoods} from "../../../../@domain/order-foods";
import {RestaurantTable} from "../../../../@domain/restaurent-table";
import {BaseComponent} from "../../../../@application/component/base.component";
import {MenuApiEnum} from "../../../../../../projects/menu/src/lib/@application/enum/menu-api.enum";
import {MenuItemOrder} from "../../../../@domain/menu-order";
import {SET_MENU_ITEM_ORDER} from "../../store/menu-order/menu-order.action";
import {AddNewFoodComponent} from "./add-new-food/add-new-food.component";
import {NonVeggie, Veggie} from "../../../../@application/common/item-type-dictionary";


@Component({
    selector: 'lib-order-menu',
    templateUrl: './order-menu.component.html',
    styleUrl: './order-menu.component.css',
    standalone: false
})
export class OrderMenuComponent extends BaseComponent implements OnInit, OnChanges {
  private apiBaseService = inject(ApiBaseService)
  private dialog = inject(MatDialog)
  public alertService = inject(AlertService)
  private store = inject(Store<fromApp.AppState>)

  menusWithFoods: ActivePosMenu[] = [];
  categoryFoods: Category[] = [];
  foodItems: CategoryFoods[] = [];
  activePos: ActivePos[] = []
  activePos_: ActivePos[] = []
  categoryKeyValue = [] as CheckOption[]
  // typeKeyValue = [] as CheckOption[]
  // searchTagKeyValue = [] as CheckOption[]
  foodItemQuantity = [] as FoodItemQuantity[]
  savedMenuItemOrder: MenuItemOrder[] = []
  cartFoods: CartRequestDetails[] = [];
  menuIds: string[] = []
  addedFilters = [] as AddedFilters[]
  category: ItemCategory[] = [];
  selectedMenuId = '';
  selectedCategory = '';
  image!: string
  currentSection = 'beverages';
  search = new Subject<any>()
  searchValue: any;
  regularQtyId!: string;
  selectedFilters = {
    category: [] as string[],
    type: [] as string[],
    searchTag: [] as string[]
  };


  @Input()
  orderDetails = {} as OrderFoods
  @Input()
  isSearching = false;
  @Input() sectionId !: string
  @ViewChildren('bodyRef') bodyRefs!: QueryList<ElementRef>;
  @Input()
  view = 'Normal'
  @Output()
  cart: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input()
  tables = [] as RestaurantTable[];

  @Output()
  newItem: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  // Keyboard navigation properties
  selectedCategoryIndex = 0;
  selectedFoodIndex = -1;
  lastSpaceTime = 0;
  lastEnterTime = 0;

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Skip if a dialog is open
    const dialogOpen = document.querySelector('.cdk-overlay-pane mat-dialog-container');
    if (dialogOpen) {
      return;
    }

    // Skip if user is typing in an input field (except for Escape)
    const activeElement = document.activeElement;
    const isInputFocused = activeElement instanceof HTMLInputElement ||
                           activeElement instanceof HTMLTextAreaElement;

    // Double Space to focus search (300ms threshold)
    if (event.key === ' ') {
      const now = Date.now();
      if (now - this.lastSpaceTime < 300) {
        event.preventDefault();
        this.focusSearch();
        this.lastSpaceTime = 0;
        return;
      }
      this.lastSpaceTime = now;
      return;
    }

    // Escape - clear selection and blur search
    if (event.key === 'Escape') {
      event.preventDefault();
      this.clearSelection();
      if (isInputFocused) {
        (activeElement as HTMLElement).blur();
      }
      return;
    }

    // Skip other shortcuts when input is focused
    if (isInputFocused) {
      return;
    }

    // Tab - navigate categories down, Shift+Tab - navigate categories up
    if (event.key === 'Tab') {
      event.preventDefault();
      if (event.shiftKey) {
        this.navigateCategory('up');
      } else {
        this.navigateCategory('down');
      }
      return;
    }

    // Arrow keys - navigate food items (all 4 directions)
    if (event.key === 'ArrowUp') {
      if (event.shiftKey) return; // Reserved for cart navigation
      event.preventDefault();
      this.navigateFood('up');
      return;
    }
    if (event.key === 'ArrowDown') {
      if (event.shiftKey) return; // Reserved for cart navigation
      event.preventDefault();
      this.navigateFood('down');
      return;
    }
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.navigateFood('left');
      return;
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.navigateFood('right');
      return;
    }

    // Enter - open add to cart dialog for selected food
    if (event.key === 'Enter' && this.selectedFoodIndex >= 0) {
      event.preventDefault();
      const selectedFood = this.foodItems[this.selectedFoodIndex];
      if (selectedFood) {
        this.onAddToCart(selectedFood);
      }
      return;
    }
  }

  private focusSearch(): void {
    if (this.searchInput?.nativeElement) {
      this.searchInput.nativeElement.focus();
      this.searchInput.nativeElement.select();
    }
  }

  private clearSelection(): void {
    this.selectedFoodIndex = -1;
    this.searchValue = '';
    this.activePos_ = this.activePos;
    this.activePosGroupByMenuId();
  }

  private navigateCategory(direction: 'up' | 'down'): void {
    if (!this.categoryFoods || this.categoryFoods.length === 0) return;

    if (direction === 'up') {
      this.selectedCategoryIndex = this.selectedCategoryIndex > 0
        ? this.selectedCategoryIndex - 1
        : this.categoryFoods.length - 1;
    } else {
      this.selectedCategoryIndex = this.selectedCategoryIndex < this.categoryFoods.length - 1
        ? this.selectedCategoryIndex + 1
        : 0;
    }

    // Select the category and reset food selection
    const category = this.categoryFoods[this.selectedCategoryIndex];
    if (category) {
      this.onSelectCategory(category.categoryName);
      this.selectedFoodIndex = -1;
    }

    // Scroll category into view
    setTimeout(() => {
      const categoryElements = document.querySelectorAll('.category-box');
      const element = categoryElements[this.selectedCategoryIndex] as HTMLElement;
      element?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 0);
  }

  private navigateFood(direction: 'left' | 'right' | 'up' | 'down'): void {
    if (!this.foodItems || this.foodItems.length === 0) return;

    const itemsPerRow = 4; // Grid is 4 columns (col-xl-3 means 12/3 = 4 items per row)

    switch (direction) {
      case 'left':
        this.selectedFoodIndex = this.selectedFoodIndex > 0
          ? this.selectedFoodIndex - 1
          : this.foodItems.length - 1;
        break;
      case 'right':
        this.selectedFoodIndex = this.selectedFoodIndex < this.foodItems.length - 1
          ? this.selectedFoodIndex + 1
          : 0;
        break;
      case 'up':
        // Move up one row (subtract itemsPerRow)
        const newUpIndex = this.selectedFoodIndex - itemsPerRow;
        this.selectedFoodIndex = newUpIndex >= 0
          ? newUpIndex
          : this.foodItems.length + newUpIndex; // Wrap to bottom
        break;
      case 'down':
        // Move down one row (add itemsPerRow)
        const newDownIndex = this.selectedFoodIndex + itemsPerRow;
        this.selectedFoodIndex = newDownIndex < this.foodItems.length
          ? newDownIndex
          : newDownIndex - this.foodItems.length; // Wrap to top
        break;
    }

    // Scroll food into view
    setTimeout(() => {
      const foodElements = document.querySelectorAll('.food-card');
      const element = foodElements[this.selectedFoodIndex] as HTMLElement;
      element?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 0);
  }

  ngOnInit(): void {
    this.subscriptions()
    // this.getItemType()
    // this.getSearchTag()
    this.searchDebounce()
  }


  private subscriptions() {
    this.subscription$.add(
      this.store.select(getPlaceOrderState)
        .subscribe({
          next: value => {
            this.cartFoods = value.cartFoods
          }
        })
    )
    this.subscription$.add(
      this.store.select(getMenuState)
        .subscribe({
          next: value => {
            this.activePos = value.menuRelatedData.activePos;
            this.activePos_ = value.menuRelatedData.activePos;
            this.foodItemQuantity = value.menuRelatedData.quantity;
            this.regularQtyId = this.foodItemQuantity.find(x => x.pricingMultiple === 1)?.id || '';
            this.category = value.menuRelatedData.category;
            this.setCategoryKeyValue(value.menuRelatedData.category);
            this.setMenus(value.menuRelatedData.section);

            if (
              value.menuRelatedData.activePos.length > 0 &&
              this.categoryKeyValue.length > 0 &&
              this.menuIds.length > 0
            ) {
              this.activePosGroupByMenuId();
            }
          }
        })
    );
    this.subscription$.add(
      this.store.select(getMenuOrderState)
        .subscribe({
          next: value => {
            const newOrder = value.menuItemOrder;
            // Only apply if selectedMenuId matches and new data is present
            if (newOrder?.length && this.selectedMenuId === newOrder[0].menuId) {
              this.savedMenuItemOrder = newOrder;
              this.addPosOrdering();
            }
          }
        })
    );

  }

  private setCategoryKeyValue(category: ItemCategory[]): void {
    this.categoryKeyValue = category.map((item: any) => {
      return {
        value: item.id,
        label: item.name,
        checked: false
      }
    })
  }

  private setMenus(sections: Section[]): void {
    if (this.view === 'POS') {
      this.menuIds = sections.find(x => x.isPos)?.menus || []
      return
    }
    this.menuIds = sections.find(x => x.id === this.sectionId)?.menus || []
  }

  searchDebounce(): void {
    this.search.pipe(debounceTime(1000))
      .subscribe({
        next: _value => {
          this.searchData()
        }
      })
  }


  getMenuFoodCount(menuItem: any): number {
    return menuItem?.foods?.reduce((count: number, category: any) => {
      return count + (category.categoryFoods?.length || 0);
    }, 0);
  }

  // toggleFilters() {
  //   const dialogRef = this.dialog.open(PlaceOrderFilterDialogComponent, {
  //     width: '80%',
  //     data: {
  //       categoryKeyValue: this.categoryKeyValue,
  //       typeKeyValue: this.typeKeyValue,
  //       searchTagKeyValue: this.searchTagKeyValue,
  //       selectedFilters: this.selectedFilters
  //     },
  //   });
  //
  //   dialogRef.componentInstance.filterChange.subscribe((selectedFilters) => {
  //     if (selectedFilters) {
  //       this.selectedFilters = selectedFilters
  //       if (selectedFilters.category) {
  //         this.applyFilter('category', selectedFilters.category);
  //       }
  //       if (selectedFilters.type) {
  //         this.applyFilter('type', selectedFilters.type);
  //       }
  //       if (selectedFilters.searchTag) {
  //         this.applyFilter('searchTag', selectedFilters.searchTag);
  //       }
  //     }
  //   });
  // }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['sectionId'] && changes['sectionId'].currentValue) {
      if (!(this.menuIds.length > 0)) {
        this.subscriptions()
      }
    }
  }

  private updateAddedFilters(filter: string, data: ActivePos[]): void {
    if (!this.addedFilters) {
      this.addedFilters = [];
    }
    switch (filter) {
      case 'category':
        if (this.addedFilters.some(x => x.name === 'category')) {
          this.addedFilters.find(x => x.name === 'category')!.data = data
        } else {
          this.addedFilters.push({name: 'category', data: data})
        }
        break;
      case 'type':
        if (this.addedFilters.some(x => x.name === 'type')) {
          this.addedFilters.find(x => x.name === 'type')!.data = data
        } else {
          this.addedFilters.push({name: 'type', data: data})
        }
        break;
      case 'searchTag':
        if (this.addedFilters.some(x => x.name === 'searchTag')) {
          this.addedFilters.find(x => x.name === 'searchTag')!.data = data
        } else {
          this.addedFilters.push({name: 'searchTag', data: data})
        }
        break;
    }
  }


  onSectionChange(sectionId: string): void {
    this.currentSection = sectionId;
  }

  onAddToCart(foodItem: ActivePos) {
    this.dialog.open(AddToCartDialogComponent, {
      width: this.isTabScreen() ? '80%' : '40%',
      data: {
        btnTitle: 'Add to Cart',
        title: foodItem.foodName,
        foodItem: foodItem,
        foodItemQuantity: this.foodItemQuantity,
        regularQtyId: this.regularQtyId
      }
    })
  }

  onCategory($event: CheckOption[]) {
    const selectedCategory = $event.filter(option => option.checked).map(option => option.value);
    this.applyFilter('category', selectedCategory);
  }

  onType($event: CheckOption[]) {
    const selectedType = $event.filter(option => option.checked).map(option => option.value);
    this.applyFilter('type', selectedType);
  }

  onSearchTag($event: CheckOption[]) {
    const selectedTag = $event.filter(option => option.checked).map(option => option.value);
    this.applyFilter('searchTag', selectedTag);
  }

  private applyFilter(filterType: string, selectedValues: string[]) {
    let filteredData: ActivePos[] = [];
    if (selectedValues.length === 0) {
      filteredData = this.getPreviousFilterData();
      this.addedFilters = this.addedFilters.filter(x => x.name !== filterType);
    } else {
      if (filterType === 'category') {
        filteredData = this.activePos.filter(food => selectedValues.includes(food.foodCategoryId));
      } else if (filterType === 'type') {
        filteredData = this.activePos.filter(food =>
          Array.isArray(food.foodTypeIds) && food.foodTypeIds.some(typeId => selectedValues.includes(typeId))
        )
      } else if (filterType === 'searchTag') {
        filteredData = this.activePos.filter(food =>
          Array.isArray(food.foodSearchTagIds) && food.foodSearchTagIds.some(tagId => selectedValues.includes(tagId))
        );
      }
      if (!filteredData) {
        filteredData = [];
      }
      this.updateAddedFilters(filterType, filteredData);
    }
    this.activePos_ = filteredData;
    this.activePosGroupByMenuId();
  }

  private getPreviousFilterData(): ActivePos[] {
    if (this.addedFilters.length === 1) {
      return this.activePos;
    }
    return this.addedFilters[this.addedFilters.length - 2]?.data || this.activePos;
  }

  liveSearch() {
    if (this.searchValue == '') {
      this.activePos_ = this.activePos;
      this.activePosGroupByMenuId()
      this.isSearching = false;
    } else {
      this.isSearching = true;
      this.search.next('')
    }
  }

  searchData() {
    this.activePos_ = this.activePos.filter((food) => {
      return food.foodName?.toLowerCase().includes(this.searchValue.toLowerCase())
        || food.foodItemCode?.toLowerCase().includes(this.searchValue.toLowerCase());
    });
    this.activePosGroupByMenuId()
    this.isSearching = false;
  }

  foodAddedQuantity(foodItem: ActivePos): string {
    const cartFoods = this.cartFoods.filter(x => x.foodId === foodItem.foodId)
    return cartFoods ? cartFoods.reduce((sum, foodItem) => sum + foodItem.quantity, 0).toString() : '';
  }

  isTabScreen(): boolean {
    return window.innerWidth <= 800;
  }

  isMobileScreen(): boolean {
    return window.innerWidth <= 500;
  }

  // onOpenImages(foodImageUrl: string | null, foodName: string) {
  //   this.dialog.open(ImageViewerComponent, {
  //     width: this.isMobileScreen() ? '100%' : this.isTabScreen() ? '80%' : '40%',
  //     maxWidth: this.isMobileScreen() ? '100vw' : this.isTabScreen() ? '80vw' : '40vw',
  //     data: {
  //       images: foodImageUrl,
  //       foodName: foodName
  //     }
  //   })
  // }

  private activePosGroupByMenuId() {
    const menuMap = [] as ActivePosMenu[];
    this.activePos_.forEach(x => {
      let menu = menuMap.find(menu => menu.menuId === x.menuId);

      // If the menu doesn't exist in the menuMap, create and add it
      if (!menu) {
        menu = {
          menuId: x.menuId,
          menuName: x.menuName,
          menuGroupId: x.menuGroupId,
          category: []
        };
        menuMap.push(menu);
      }

      const foodCategoryName = this.categoryKeyValue.find(y => y.value === x.foodCategoryId)?.label;

      // Find the category within the current menu
      let category = menu.category.find(c => c.categoryName === foodCategoryName);
      let categoryPosViewOrder = 0;
      if (this.savedMenuItemOrder.length > 0) {
        categoryPosViewOrder = this.savedMenuItemOrder
          .find(y => y.referenceId === x.foodCategoryId && y.referenceType === 'FoodCategory')?.order!
      }
      // If the category doesn't exist, create it
      if (!category) {
        category = {
          categoryId: x.foodCategoryId,
          categoryName: foodCategoryName,
          posViewOrder: categoryPosViewOrder,
          categoryFoods: []
        };
        menu.category.push(category);
      }

      let foodPosViewOrder = 0;
      if (this.savedMenuItemOrder.length > 0) {
        foodPosViewOrder = this.savedMenuItemOrder
          .find(y => y.referenceId === x.foodId && y.referenceType === 'Food')?.order!
      }

      // Add the food to the category's food array
      category.categoryFoods.push({
        ...x,
        posViewOrder: foodPosViewOrder,
        imageUrls: x.imageUrls ?? null
      });
    });

    // Optionally, sort the categories and their foods if necessary
    menuMap.forEach(menu => {
      // Sorting categories by name (optional)
      menu.category.sort((a, b) => a.posViewOrder! - b.posViewOrder!);
      // Sorting the foods within each category (optional)
      menu.category.forEach((category) => {
        category.categoryFoods.sort((a, b) => a.posViewOrder! - b.posViewOrder!);
      });
    });
    const menu = Array.from(menuMap.values());
    this.menusWithFoods = menu.filter(menu => this.menuIds.includes(menu.menuId))
    this.setInitialData()
  }

  private setInitialData(): void {
    if (this.menusWithFoods.length === 0) {
      this.alertService.showInfo('Info', 'No food menu available for this section')
      return;
    }
    this.selectedMenuId = this.menusWithFoods[0].menuId
    this.categoryFoods = this.menusWithFoods[0].category
    this.selectedCategory = this.categoryFoods[0].categoryName
    this.foodItems = this.categoryFoods[0].categoryFoods
    if (this.savedMenuItemOrder.length === 0) {
      this.getMenuItemOrder(this.selectedMenuId)
    }
  }

  private addPosOrdering() {
    const menu = this.menusWithFoods.find(x => x.menuId === this.selectedMenuId);
    if (!menu) return;

    // Map orders for quick lookup
    const orderMap = new Map<string, number>();
    for (const item of this.savedMenuItemOrder) {
      orderMap.set(`${item.referenceType}_${item.referenceId}`, item.order);
    }

    // Assign and sort categories
    menu.category.forEach(category => {
      category.posViewOrder = orderMap.get(`FoodCategory_${category.categoryId}`) ?? 0;

      // Assign and sort foods within each category
      category.categoryFoods.forEach(food => {
        food.posViewOrder = orderMap.get(`Food_${food.foodId}`) ?? 0;
      });

      // Sort foods by posViewOrder
      category.categoryFoods.sort((a, b) => a.posViewOrder! - b.posViewOrder!);
    });

    // Sort categories by posViewOrder
    menu.category.sort((a, b) => a.posViewOrder! - b.posViewOrder!);
    this.selectedMenuId = this.menusWithFoods[0].menuId
    this.categoryFoods = this.menusWithFoods[0].category
    this.selectedCategory = this.categoryFoods[0].categoryName
    this.foodItems = this.categoryFoods[0].categoryFoods
  }


  onMenuChange(menuId: string): void {
    this.selectedMenuId = menuId;
    this.categoryFoods = this.menusWithFoods.find(x => x.menuId === menuId)?.category || [];
    this.selectedCategory = this.categoryFoods[0].categoryName;
    this.foodItems = this.categoryFoods[0].categoryFoods;
    this.getMenuItemOrder(this.selectedMenuId)
  }

  private getMenuItemOrder(menuId: string): void {
    const params = new HttpParams().append('$filter', `menuId eq ${menuId}`);
    this.apiBaseService.GET<MenuItemOrder[]>(
      [MenuApiEnum.FoodModule, MenuApiEnum.MenuItemOrder],
      false, true, params
    ).subscribe({
      next: response => {
        if (
          response.length === 0 ||
          this.savedMenuItemOrder?.[0]?.menuId === this.selectedMenuId
        ) {
          return;
        }
        this.store.dispatch(SET_MENU_ITEM_ORDER({payload: response}));
      }
    });
  }

  getQtyTagName(foodQuantityTagId: string): string {
    return this.foodItemQuantity.find(x => x.id === foodQuantityTagId)?.name.charAt(0).toUpperCase() ?? '';
  }

  getSortedQuantityTags(tags: any[]) {
    return tags?.slice().sort((a, b) => a.additionalPrice - b.additionalPrice);
  }


  // private getItemType(): void {
  //   this.apiBaseService.GET<FoodItemType[]>([ApiEnum.FoodModule, ApiEnum.FoodType], false)
  //     .subscribe({
  //       next: res => {
  //         this.typeKeyValue = res.map((item: any) => {
  //           return {
  //             value: item.id,
  //             label: item.name,
  //             checked: false
  //           }
  //         })
  //       }
  //     })
  // }

  // private getSearchTag(): void {
  //   this.apiBaseService.GET<FoodItemSearchTag[]>([ApiEnum.FoodModule, ApiEnum.FoodItemSearchTag], false)
  //     .subscribe({
  //       next: res => {
  //         this.searchTagKeyValue = res.map((item: any) => {
  //           return {
  //             value: item.id,
  //             label: item.name,
  //             checked: false
  //           }
  //         })
  //       }
  //     })
  // }


  // private getFoodTemplate(): void {
  //   this.apiBaseService.GET<AppImage[]>([ApiEnum.RestaurantModule, ApiEnum.SystemSetting, ApiEnum.AppImage, ApiEnum.FoodTemplate])
  //     .subscribe({
  //       next: res => {
  //         this.image = res[0].customerAppImages.imageUrl
  //       }
  //     })
  // }

  onSelectCategory(categoryName: string) {
    this.selectedCategory = categoryName;
    this.selectedCategoryIndex = this.categoryFoods.findIndex(x => x.categoryName === categoryName);
    this.foodItems = this.categoryFoods.find(x => x.categoryName === categoryName)?.categoryFoods || [];
  }

  onAddFood() {
    const dialogRef = this.dialog.open(AddNewFoodComponent, {
      width: '80%',
      data: {
        menuId: this.selectedMenuId,
        categoryId: this.category.find(x => x.name === this.selectedCategory)?.id || '',
        categories: this.category,
        foodItemQuantity: this.foodItemQuantity
      }
    })

    dialogRef.afterClosed().subscribe({
      next: value => {
        if (value != true) {
          this.newItem.next(true)
        }
      }
    })
  }

  checkNonVeggieStatus(foodTypeNames: string[] | undefined): boolean {
    if (!foodTypeNames || foodTypeNames.length === 0) {
      return false;
    }
    return foodTypeNames.some(type => NonVeggie.includes(type));
  }

  checkVeggieStatus(foodTypeNames: string[] | undefined): boolean {
    if (!foodTypeNames || foodTypeNames.length === 0) {
      return false;
    }
    return foodTypeNames.some(type => Veggie.includes(type));
  }
}

export interface AddedFilters {
  name: string,
  data: ActivePos[]
}
